import { findIndex } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { Grid, Icon, Tooltip } from '@mui/material'
import { actionIconStyle } from 'components/ActionUtil'

const FastArrowNav = ({ nav }) => {
    const getArrowElement = (item, direction) => {
        const onClick = item ? () => nav.onClick(item) : () => { }
        const tooltip = item ? nav.labels.map(o => {
            const labelItem = item[o]
            if (labelItem) {
                return (labelItem.value || labelItem.value === '') ? labelItem.value : labelItem
            }
            return ''
        }).join(' - ') : ''
        return (
            <Tooltip title={tooltip}>
                <Icon
                    key={item ? item.id : 0}
                    onClick={onClick}
                    data-cy={`arrow_${direction}`}
                    sx={{ ...actionIconStyle, cursor: item ? 'pointer' : 'default', color: item ? 'white' : 'darkgrey' }}
                >
                    {`arrow_drop_${direction}`}
                </Icon>
            </Tooltip>
        )
    }

    const array = nav.array
    const current = findIndex(array, o => o.id === nav.currentId)
    const position = `${current + 1} sur ${array.length}`
    const prevArrow = getArrowElement(current === 0 ? null : array[current - 1], 'up')
    const postArrow = getArrowElement(current + 1 === array.length ? null : array[current + 1], 'down')
    return (
        <Grid id='fast_arrow_nav' container alignItems={'center'} px={2} >
            {position}
            {prevArrow}
            {postArrow}
        </Grid>
    )
}

FastArrowNav.propTypes = {
    nav: PropTypes.shape({
        currentId: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        array: PropTypes.array,
        labels: PropTypes.arrayOf(PropTypes.string),
        onClick: PropTypes.func,
    }),
}

export default FastArrowNav
